<era-location-select-ui [locations]="locations()"
                        [location]="location()"
                        (locationChange)="selected($event)"
                        [isEnabled]="isEnabled()"></era-location-select-ui>